import { v4 as uuidv4 } from 'uuid';

import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { Menu } from '../../../../vtex-apps/menu/Menu/default';
import { MenuItem } from '../../../../vtex-apps/menu/MenuItem/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { Image } from '../../../../vtex-apps/store-components/Image/default';
import { StoreImageList } from '../../../../vtex-apps/store-image-list/StoreImageList/default';
import { ListContextRenderer } from '../../../../vtex-apps/list-context/ListContextRenderer/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

export default function FooterDesktop() {
	return {
		componentName: 'FooterDesktop',
		componentId: uuidv4(),
		componentGroup: 'FooterDesktop',
		props: {
			mzTitle: 'MZ | Footer - Desktop',
		},
		variables,
		childrenComponents: [
			FlexLayoutRow(
				{
					blockClass: 'footer-desktop-3-logo',
					colSizing: 'auto',
					horizontalAlign: 'center',
				},
				[
					Image({
						src: 'https://hefesto-upload-images.s3.amazonaws.com/1683046479085-JdNwrJt.png',
					}),
				],
			),
			FlexLayoutRow(
				{
					blockClass: 'footer-desktop-3-content',
					colSizing: 'auto',
				},
				[
					FlexLayoutCol({ blockClass: 'footer-desktop-3-content__col' }, [
						FlexLayoutRow({ blockClass: 'footer-desktop-3-content-wrapper' }, [
							VisibilityLayout({ mzTitle: 'MZ | Coluna A Loja (On/Off)' }, [
								FlexLayoutCol({}, [
									Menu({
										blockClass: 'footer-desktop-3-content__menu',
										orientation: 'vertical',
										items: [
											MenuItem({
												blockClass: 'footer-desktop-3-content__menu-item',
												highlight: true,
												itemProps: {
													href: '/#',
													text: 'A [nome loja]',
												},
											}).props,
											MenuItem({
												blockClass: 'footer-desktop-3-content__menu-item',
												itemProps: {
													href: '/#',
													text: 'Quem Somos',
												},
											}).props,
											MenuItem({
												blockClass: 'footer-desktop-3-content__menu-item',
												itemProps: {
													href: '/#',
													text: 'Nossas Lojas',
												},
											}).props,
											MenuItem({
												blockClass: 'footer-desktop-3-content__menu-item',
												itemProps: {
													href: '/#',
													text: 'Trabalhe Conosco',
												},
											}).props,
											MenuItem({
												blockClass: 'footer-desktop-3-content__menu-item',
												itemProps: {
													href: '/#',
													text: 'Seja Revendedor',
												},
											}).props,
										],
									}),
								]),
							]),
							VisibilityLayout({ mzTitle: 'MZ | Coluna Política e Ajuda (On/Off)' }, [
								FlexLayoutCol({}, [
									Menu({
										blockClass: 'footer-desktop-3-content__menu',
										orientation: 'vertical',
										items: [
											MenuItem({
												blockClass: 'footer-desktop-3-content__menu-item',
												highlight: true,
												itemProps: {
													href: '/#',
													text: 'Política e Ajuda',
												},
											}).props,
											MenuItem({
												blockClass: 'footer-desktop-3-content__menu-item',
												itemProps: {
													href: '/#',
													text: 'Como comprar no nosso site',
												},
											}).props,
											MenuItem({
												blockClass: 'footer-desktop-3-content__menu-item',
												itemProps: {
													href: '/#',
													text: 'Formas de Compra e Entrega',
												},
											}).props,
											MenuItem({
												blockClass: 'footer-desktop-3-content__menu-item',
												itemProps: {
													href: '/#',
													text: 'Política de Troca e Devolução',
												},
											}).props,
											MenuItem({
												blockClass: 'footer-desktop-3-content__menu-item',
												itemProps: {
													href: '/#',
													text: 'Política de Privacidade LGPD',
												},
											}).props,
											MenuItem({
												blockClass: 'footer-desktop-3-content__menu-item',
												itemProps: {
													href: '/#',
													text: 'Fale Conosco',
												},
											}).props,
										],
									}),
								]),
							]),
							VisibilityLayout({ mzTitle: 'MZ | Coluna Sua Conta (On/Off)' }, [
								FlexLayoutCol({}, [
									Menu({
										blockClass: 'footer-desktop-3-content__menu',
										orientation: 'vertical',
										items: [
											MenuItem({
												blockClass: 'footer-desktop-3-content__menu-item',
												highlight: true,
												itemProps: {
													href: '/',
													text: 'Sua Conta',
												},
											}).props,
											MenuItem({
												blockClass: 'footer-desktop-3-content__menu-item',
												itemProps: {
													href: '/account',
													text: 'Minha Conta',
												},
											}).props,
											MenuItem({
												blockClass: 'footer-desktop-3-content__menu-item',
												itemProps: {
													href: '/account#/orders',
													text: 'Meus Pedidos',
												},
											}).props,
											MenuItem({
												blockClass: 'footer-desktop-3-content__menu-item',
												itemProps: {
													href: '/#',
													text: 'Meus Favoritos',
												},
											}).props,
											MenuItem({
												blockClass: 'footer-desktop-3-content__menu-item',
												itemProps: {
													href: '/#',
													text: 'Notificação por email',
												},
											}).props,
										],
									}),
								]),
							]),
							VisibilityLayout({ mzTitle: 'MZ | Coluna Menu Adicional (On/Off)' }, [
								FlexLayoutCol({}, [
									Menu({
										blockClass: 'footer-desktop-3-content__menu',
										orientation: 'vertical',
										items: [
											MenuItem({
												blockClass: 'footer-desktop-3-content__menu-item',
												highlight: true,
												itemProps: {
													href: '/',
													text: 'Menu Adcional',
												},
											}).props,
											MenuItem({
												blockClass: 'footer-desktop-3-content__menu-item',
												itemProps: {
													href: '/account',
													text: 'Link menu adicional #1',
												},
											}).props,
											MenuItem({
												blockClass: 'footer-desktop-3-content__menu-item',
												itemProps: {
													href: '/account#/orders',
													text: 'Link menu adicional #2',
												},
											}).props,
											MenuItem({
												blockClass: 'footer-desktop-3-content__menu-item',
												itemProps: {
													href: '/#',
													text: 'Link menu adicional #3',
												},
											}).props,
										],
									}),
								]),
							]),
						]),
						FlexLayoutRow(
							{
								blockClass: 'footer-desktop-3-content__payment',
								horizontalAlign: 'between',
								colSizing: 'auto',
							},
							[
								VisibilityLayout({ mzTitle: 'MZ | Coluna Pagamento (On/Off)' }, [
									FlexLayoutCol({ width: '50%' }, [
										RichText({
											text: '**Formas de pagamento e bandeiras aceitas**',
											blockClass: 'footer-desktop-3-content__title',
											textAlignment: 'left',
											textPosition: 'left',
										}),
										FlexLayoutRow({}, [
											StoreImageList(
												{
													height: 36,
													images: [
														{
															src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166279-payment-system-mastercard.png',
															alt: 'MasterCard',
															title: 'MasterCard',
														},
														{
															src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166279-payment-system-visa.png',
															alt: 'Visa',
															title: 'Visa',
														},
														{
															src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166278-payment-system-hipercard.png',
															alt: 'Hipercard',
															title: 'Hipercard',
														},
														{
															src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166278-payment-system-hiper.png',
															alt: 'Hiper',
															title: 'Hiper',
														},
														{
															src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166277-payment-system-dinersclub.png',
															alt: 'Diners Club',
															title: 'Diners Club',
														},
														{
															src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166279-payment-system-jcb.png',
															alt: 'JCB',
															title: 'JCB',
														},
														{
															src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166277-payment-system-discover.png',
															alt: 'Discover',
															title: 'Discover',
														},
														{
															src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166278-payment-system-elo.png',
															alt: 'Elo',
															title: 'Elo',
														},
														{
															src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166277-payment-system-boleto.png',
															alt: 'Boleto',
															title: 'Boleto',
														},
														{
															src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166279-payment-system-pix.png',
															alt: 'Pix',
															title: 'Pix',
														},
													],
												},
												[
													ListContextRenderer({
														blockClass: 'footer-desktop-3-payment__list',
														listElement: 'ul',
														itemElement: 'li',
													}),
												],
											),
										]),
									]),
								]),
							],
						),
					]),
					FlexLayoutCol(
						{
							blockClass: 'footer-desktop-3-content__col',
						},
						[
							VisibilityLayout({ mzTitle: 'MZ | Coluna Atendimento (On/Off)' }, [
								FlexLayoutRow({}, [
									FlexLayoutCol({}, [
										RichText({
											text: '**Atendimento**',
											blockClass: 'footer-desktop-3-content__title',
											textAlignment: 'left',
											textPosition: 'left',
										}),
										RichText({
											text: 'De segunda a sexta, das 9h as 18h.',
											blockClass: 'footer-desktop-3-content__atendimento',
											textAlignment: 'left',
											textPosition: 'left',
										}),
										RichText({
											text: 'Telefones: (00) 0000-0000 / (00) 0 0000-0000',
											blockClass: 'footer-desktop-3-content__atendimento',
											textAlignment: 'left',
											textPosition: 'left',
										}),
										RichText({
											text: 'E-mail: [contato@nomeloja.com.br](mailto:contato@nomeloja.com.br)',
											blockClass: 'footer-desktop-3-content__atendimento',
											textAlignment: 'left',
											textPosition: 'left',
										}),
									]),
								]),
							]),
							VisibilityLayout({ mzTitle: 'MZ | Coluna Social (On/Off)' }, [
								FlexLayoutRow({}, [
									FlexLayoutCol({}, [
										RichText({
											text: '**Nossas Redes Sociais**',
											textAlignment: 'left',
											textPosition: 'left',
											blockClass: 'footer-desktop-3-content__title',
										}),
										FlexLayoutRow(
											{
												horizontalAlign: 'left',
												colSizing: 'auto',
												blockClass: 'footer-desktop-3-social-icons',
											},
											[
												StoreImageList(
													{
														height: 12,
														images: [
															{
																description: 'Facebook',
																src: 'https://hefesto-upload-images.s3.amazonaws.com/1683046717711-212365083-5b98cc81-5847-402a-9ab8-290df2ccb242.png',
																link: {
																	url: 'https://www.facebook.com/',
																	newTab: true,
																},
															},
															{
																description: 'Instagram',
																src: 'https://hefesto-upload-images.s3.amazonaws.com/1683046730547-212365091-d67ff0ac-e491-4e2b-bee6-087f6eb20031.png',
																link: {
																	url: 'https://www.instagram.com/',
																	newTab: true,
																},
															},
															{
																description: 'Twitter',
																src: 'https://hefesto-upload-images.s3.amazonaws.com/1683046743459-212365094-c5cd4039-4f34-42e6-9115-e6c034297413.png',
																link: {
																	url: 'https://twitter.com/',
																	newTab: true,
																},
															},
															{
																alt: 'TikTok',
																src: 'https://hefesto-upload-images.s3.amazonaws.com/1693331955678-tiktok.png',
																link: {
																	url: 'https://tiktok.com/',
																	newTab: true,
																},
															},
														],
													},
													[
														ListContextRenderer({
															blockClass: 'footer-desktop-3-social-icons__list',
															listElement: 'ul',
															itemElement: 'li',
														}),
													],
												),
											],
										),
									]),
								]),
							]),
							VisibilityLayout({ mzTitle: 'MZ | Coluna Selos de Segurança (On/Off)' }, [
								FlexLayoutCol(
									{
										width: '20%',
									},
									[
										RichText({
											text: '**Selos de segurança**',
											blockClass: 'footer-desktop-3-content__title',
											textAlignment: 'left',
											textPosition: 'left',
										}),
										FlexLayoutRow(
											{
												blockClass: 'footer-desktop-3--high',
												fullWidth: true,
											},
											[
												StoreImageList(
													{
														height: 55,
														images: [
															{
																src: 'https://hefesto-upload-images.s3.amazonaws.com/1676318216942-eureciclo.png',
																alt: 'Eureciclo',
																title: 'SeloEu Reciclo',
																link: {
																	url: '',
																},
															},
															{
																src: 'https://hefesto-upload-images.s3.amazonaws.com/1676318175602-ebit.png',
																alt: 'Ebit',
																title: 'Selo Ebit',
																link: {
																	url: '',
																},
															},
															{
																src: 'https://hefesto-upload-images.s3.amazonaws.com/1676318302329-lets-encrypt.png',
																alt: 'Let`s Encript',
																title: 'Selo Let`s Encript',
																link: {
																	url: '',
																},
															},
														],
													},
													[
														ListContextRenderer({
															blockClass: 'footer-desktop-3-security__flags',
															listElement: 'ul',
															itemElement: 'li',
														}),
													],
												),
											],
										),
									],
								),
							]),
						],
					),
				],
			),

			FlexLayoutRow(
				{
					blockClass: 'footer-desktop-3-description',
				},
				[
					FlexLayoutCol({}, [
						RichText({
							text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Malesuada quis sit massa rutrum vestibulum. Consequat neque, sit mattis rutrum ullamcorper in lectus adipiscing. Nisl, natoque mauris lectus cursus. Felis tristique quis faucibus mauris et id massa nulla. Condimentum...',
							blockClass: 'footer-desktop-3-description__text',
						}),
						RichText({
							text: '[Loja](/about)',
							blockClass: 'footer-desktop-3-description__link',
						}),
					]),
				],
			),
			FlexLayoutRow(
				{
					blockClass: 'footer-desktop-3-legal-info',
					horizontalAlign: 'between',
					colSizing: 'auto',
				},
				[
					RichText({
						text: '[NOME EMPRESA] LTDA - CNPJ: 00.000.000/0001-00 [RUA OU AVENIDA], 000 - [BAIRRO], [CIDADE] - [UF], CEP 00000-000',
						blockClass: 'footer-desktop-3-legal-text',
					}),
					FlexLayoutRow({}, [
						FlexLayoutCol({}, [
							RichText({
								text: 'Powered by',
								blockClass: 'footer-desktop-3-legal-title',
								textAlignment: 'left',
								textPosition: 'left',
							}),
							Image({
								src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166277-logo-checkout-vtex.png',
								title: 'VTEX',
								link: {
									url: 'https://vtex.com/',
									openNewTab: true,
								},
								blockClass: 'footer-desktop-3',
							}),
						]),
						FlexLayoutCol({}, [
							RichText({
								text: 'Desenvolvido',
								blockClass: 'footer-desktop-3-legal-title',
								textAlignment: 'left',
								textPosition: 'left',
							}),
							Image({
								src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166276-logo-checkout-maeztra.png',
								title: 'Maeztra',
								link: {
									url: 'https://maeztra.com/',
									openNewTab: true,
								},
								blockClass: 'footer-desktop-3',
							}),
						]),
					]),
				],
			),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{
				from: '--white',
				to: '--footer-desktop-3-background',
				name: 'Background Color',
			},
			{
				from: '--brand-color-primary-pure',
				to: '--footer-desktop-3-highlight-color',
				name: 'Highlight Color',
			},
			{
				from: '--brand-color-secondary-pure',
				to: '--footer-desktop-3-main-color',
				name: 'Main Color',
			},
			{
				from: '--brand-color-primary-light',
				to: '--footer-desktop-3-hover-color',
				name: 'Hover Color',
			},
			{
				from: '--text-color-1',
				to: '--footer-desktop-3-legal-text-color',
				name: 'Legal text color',
			},
			{
				from: '--brand-color-secondary-pure',
				to: '--footer-desktop-3-social-color',
				name: 'Social Media Color',
			},
		],
	},
	{
		type: 'fontSize',
		list: [
			{
				from: '--font-size-sm',
				to: '--footer-desktop-3-main-size',
				name: 'Main font Size',
			},
		],
	},
	{
		type: 'spacing',
		list: [{ from: '--spacing-atom', to: '--footer-3-social-spacing', name: 'Social Media padding' }],
	},
	{
		type: 'borderRadius',
		list: [{ from: 0, to: '--footer-3-social-radius', name: 'Social Media Border Radius' }],
	},
];
